module.exports = __webpack_public_path__ + "img/none.74f9ecfb.svg";